import React, { useEffect, useState } from "react";
import ReportData from "../../../api/ReportData";
import { ItemSerialisationReport } from "./ItemSerialisationReport";
import { observer } from "mobx-react-lite";
import { FilterBtnV1 } from "../../UI/button/FilterBtnV1";
import { runInAction } from "mobx";
import Media from "../../../api/Media";
import { ContainerSubTitleGrey } from "../../ContainerSubTitleGrey";
import {
  SERIAL_METRIC_FIELDS,
  serialisationGridTemplateStyle,
} from "../../../utils/serialisationReportUtils";

const METRIC_HEADERS = {
  verify: { label: "Верификация", shortLabel: "Вериф" },
  incident: { label: "Инциденты", shortLabel: "Инц" },
  defect: { label: "Брак", shortLabel: "Брак" },
  print: { label: "Напечатано", shortLabel: "Печать" },
};

const initialSortTable = () => {
  const base = {
    verify: true,
    verifyAB: true,
    verifyBA: false,
  };
  for (const field of SERIAL_METRIC_FIELDS) {
    if (field === "verify") {
      continue;
    }
    base[field] = false;
    base[`${field}AB`] = false;
    base[`${field}BA`] = false;
  }
  return base;
};

export const ListSerialisationReport = observer(
  ({ columnVisibility, rows, companys }) => {
    const [sortTable, setSortTable] = useState(initialSortTable);
    const gridStyle = serialisationGridTemplateStyle(columnVisibility);

    useEffect(() => {
      runInAction(() => {
        ReportData.sortSerialisation(sortTable);
      });
    }, [sortTable]);

    const toggleSort = (field) => {
      setSortTable((prev) => {
        const isActive = prev[field];
        const next = initialSortTable();
        next[field] = true;
        next[`${field}AB`] = isActive ? !prev[`${field}AB`] : true;
        next[`${field}BA`] = isActive ? !prev[`${field}BA`] : false;
        return next;
      });
    };

    const SortableHeader = ({ label, shortLabel, field }) => (
      <span className="cc-v4-soft-th-static reports-th-sortable reports-th-numeric">
        <span className="cc-v4-soft-th-label">
          {!Media.mobile ? label : shortLabel}
        </span>
        <FilterBtnV1
          onClick={() => toggleSort(field)}
          active={sortTable[field]}
        />
      </span>
    );

    if (!rows.length) {
      return (
        <ContainerSubTitleGrey text="Нет данных по заданному фильтру" />
      );
    }

    return (
      <div className="cc-v4-soft-list-root">
        <div
          className="cc-v4-soft-header cc-v4-soft-grid reports-serialisation-grid"
          style={gridStyle}
        >
          <span className="cc-v4-soft-th-static">
            <span className="cc-v4-soft-th-label">Компания</span>
          </span>
          <span className="cc-v4-soft-th-static">
            <span className="cc-v4-soft-th-label">ИНН</span>
          </span>
          <span className="cc-v4-soft-th-static">
            <span className="cc-v4-soft-th-label">Ответственный менеджер</span>
          </span>
          <span className="cc-v4-soft-th-static">
            <span className="cc-v4-soft-th-label">Менеджер сопровождения</span>
          </span>
          {SERIAL_METRIC_FIELDS.map((field) =>
            columnVisibility[field] ? (
              <SortableHeader
                key={field}
                label={METRIC_HEADERS[field].label}
                shortLabel={METRIC_HEADERS[field].shortLabel}
                field={field}
              />
            ) : null,
          )}
        </div>
        <div className="cc-v4-soft-body">
          {rows.map((s) => (
            <ItemSerialisationReport
              key={s.inn}
              s={s}
              columnVisibility={columnVisibility}
              gridStyle={gridStyle}
              companys={companys}
            />
          ))}
        </div>
      </div>
    );
  },
);
